import { blobResponseHandler, providesList } from '@/shared/helpers/api';
import { t } from '@/core/localization';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { enqueueSnackbar } from 'notistack';
// TODO: later check if Articles is needed (it is needed in old stock.api)
// export const stocksSharedTagTypes = ['StockList', 'Stock', 'Crossdocking', 'Articles'] as const;
export const stocksSharedTagTypes = ['StockList', 'Stock', 'Crossdocking'];
export const buildGetStockListEndpoint = (builder) => builder.query({
    query: () => {
        return {
            method: 'GET',
            url: 'stock/stockslist',
        };
    },
    transformResponse: (response) => ({ stock: response[1], transfer: response[2] }),
    providesTags: ['StockList'],
    onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
            await queryFulfilled;
        }
        catch (error) {
            dispatch(showApiErrorSnackbar({ header: t('get.stock.list.request.failed'), error }));
        }
    },
});
// TODO: check! Is overridden in stocks.api.ts. But this is the same OLD BACKEND endpoint.
export const buildGetStockInfoEndpoint = (builder) => builder.query({
    query: (stockId) => {
        return {
            method: 'GET',
            url: `stock/getStock/${stockId}`,
        };
    },
    onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
            await queryFulfilled;
        }
        catch (error) {
            dispatch(showApiErrorSnackbar({ header: t('get.stock.info.request.failed'), error }));
        }
    },
});
export const buildGetStockBalanceEndpoint = (builder) => builder.query({
    query: ({ stockId, grouped }) => {
        return {
            method: 'GET',
            url: 'stock/stockBalance',
            params: { type: grouped ? 2 : 1, stockId },
        };
    },
    transformResponse: (response, meta, { grouped }) => grouped ? response : [{ cell: undefined, stockItems: response }],
    providesTags: ['Stock'],
});
export const buildExportStockToExcelEndpoint = (builder) => builder.mutation({
    queryFn: async ({ stockId }, api, extraOptions, baseQuery) => {
        const result = (await baseQuery({
            method: 'GET',
            url: `Stock/exportStockToXlsx/${stockId}`,
            cache: 'no-cache',
            // responseHandler: (response) => response.blob(),
            responseHandler: blobResponseHandler,
        }));
        if (result.error) {
            enqueueSnackbar({
                variant: 'error',
                header: t('file.download.failed'),
                body: getErrorFromException(result.error),
                persist: true,
            });
            return { data: null };
        }
        // TODO: extract (same used in other api's (Warehouse > receipt.api))
        const hiddenElement = document.createElement('a');
        const url = window.URL || window.webkitURL;
        const blob = url.createObjectURL(result.data);
        hiddenElement.href = blob;
        hiddenElement.target = '_blank';
        hiddenElement.download = `${t('file.name.stock')}.xlsx`;
        hiddenElement.click();
        URL.revokeObjectURL(blob);
        return { data: null };
    },
});
export const buildGetCrossdockLookupEndpoint = (builder) => builder.query({
    // TODO: refactor. This endpoint is duplicated. It is used in Admin > Settings > Warehouses, and in
    // Warehouse > CrossdockingSelect component.
    query: () => 'crossdocking',
    // TODO: to return later when separate 'crossdocking' endpoint will be added.
    providesTags: (result) => providesList(result, 'Crossdocking'),
});
export const buildGetStockLocationsEndpoint = (builder) => builder.query({
    query: () => 'location',
    onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
            await queryFulfilled;
        }
        catch (error) {
            dispatch(showApiErrorSnackbar({ header: t('get.locations.request.failed'), error }));
        }
    },
});
export function buildRelocateStockItemEndpoint(builder) {
    return builder.mutation({
        query: (body) => ({
            method: 'POST',
            url: 'stock/relocate',
            body,
        }),
        // invalidatesTags: (result, error, stockItems) => stockItems.map((item) => ({ type: 'StockItem', id: item.stockItemId })),
        invalidatesTags: () => [{ type: 'Stock' }, { type: 'StockList' }],
    });
}
